<template>
  <div>
    <h1 class="title has-text-centered">Evaluar</h1>
    <hr>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
      <form autocomplete="off" @submit.prevent="handleSubmit(showResults)">
      <b-table
        ref="evaluationtable"
        :data="exercises"
        :bordered="false"
        :opened-detailed.sync="defaultOpenedDetails"
        detail-key="id"
        :mobile-cards="false"
        :show-detail-icon="false"
        detailed
        class="selected-rows"
        :selected="selected"
        @click="selectRow"
        :loading="isLoading" :key="componentKey">

        <template slot-scope="props">

            <b-table-column field="name" label="Ejercicio">
              <div style="min-width: 80px;">
                {{props.row.name}}
                <span class="has-text-grey" style="float: right;" v-if="props.row.saving">Guardando ...</span>
              </div>
            </b-table-column>

            <b-table-column field="score"  label="Nota"  width="110" style="min-width: 50px;" centered>
              <ValidationProvider v-if="!props.row.disabled_evaluate" :name="`Puntaje ${props.index+1}`" :rules="`required|oneOf:${numbers}|min_value:1|max_value:10`" v-slot="{ errors }">
                <b-tooltip :label="errors[0] ? errors[0] : ''" :type="errors[0] ? 'is-danger' : 'is-primary' ">
                  <b-field
                    :type="{ 'is-danger': errors[0] }">
                    <b-input type="text" v-model="props.row.base_score" @input="calcTotalScore(props.row)" @focus="selectRow(props.row)">
                    </b-input>
                  </b-field>
                </b-tooltip>
              </ValidationProvider>
            </b-table-column>

            <b-table-column field="coeficent" width="60" label="Coef" centered>
              <span v-if="!props.row.disabled_evaluate">
                {{props.row.coefficient}}
              </span>
            </b-table-column>

            <b-table-column field="total"  label="Total" width="60" centered>
                <span v-if="!props.row.disabled_evaluate" class="totalScore">{{ props.row.total_score }}</span>
            </b-table-column>

            <b-table-column field="observation" label="Observación" width="400" style="min-width: 100px; max-width: 150px;" :visible="windowWidth >= 1024" centered>
              <b-input type="text" v-model="props.row.observation" @focus="selectRow(props.row)"  >
              </b-input>
            </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <div>
              <tr v-for="action_position in props.row.actions_positions" :key="action_position.id">
                  <td>{{action_position.position ? action_position.position.name : ''}}</td>
                  <td>{{action_position.action ? action_position.action.name : ''}}</td>
              </tr>
              <b-field label="Observación" label-position="inside" class="is-hidden-desktop">
                <b-input type="text" @focus="selectRow(props.row)">
                </b-input>
              </b-field>
          </div>
        </template>

        <section class="section" slot="empty">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>Cargando datos...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="horseshoe" size="is-large" />
              </p>
              <p>No hay datos&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
      <hr>
      <div class="columns is-mobile is-centered">
        <div class="column is-half">
          <b-button type="is-primary" size="is-medium" native-type="submit" :disabled="invalid" expanded>Ver Resultados</b-button>
        </div>
      </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>

import ExerciseService from '@/services/ExerciseService'
import ExecutionService from '@/services/ExecutionService'
import CredentialsService from '@/services/CredentialsService'

export default {
  props: {
    lessonId: {
      required: true
    },
    executionId: {
      required: true
    },
    lesson: {
      required: true
    },
    judges: {
      required: true
    }
  },
  created () {
    this.mapExercisesResults()
  },
  mounted () {
    this.$nextTick(() => {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.onResize)
    })
  },
  data () {
    const numbers = '1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10'
    return {
      windowWidth: 0,
      selected: null,
      isLoading: false,
      exercises: [],
      defaultOpenedDetails: [],
      componentKey: 0,
      numbers: numbers,
      arrayNumbers: numbers.split(',')
    }
  },
  methods: {
    async showResults () {
      this.saveResult(this.selected)
      const scores = this.exercises
      this.$emit('show-results', scores)
    },
    calcTotalScore (row) {
      if (!row.disabled_evaluate && row.base_score && this.validateNumber(row.base_score)) {
        row.total_score = parseFloat(row.base_score) * parseInt(row.coefficient)
      } else {
        row.total_score = null
      }
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    selectRow (row) {
      this.selected = row
    },
    async mapExercisesResults () {
      this.isLoading = true
      let exectisesList = await this.getExercises()
      let judgesResult = await this.getJudgesResultsExercises()
      let mapExercises = exectisesList.map((exercise, index) => {
        let results = judgesResult.find((x) => x.order === exercise.order)
        let judegeObjc = {
          observation: null,
          base_score: null,
          total_score: null
        }
        if (results) {
          judegeObjc = {
            observation: results.observation,
            base_score: results.base_score,
            total_score: results.total_score
          }
        }
        return {
          ...exercise,
          ...judegeObjc,
          saving: false
        }
      })
      this.forceRerender()
      this.exercises = mapExercises
      this.selected = this.exercises[0]
      this.isLoading = false
    },
    async getExercises () {
      if (this.lessonId == null) {
        return []
      }
      let params = {
        'include[0]': 'actionsPositions.action',
        'include[1]': 'actionsPositions.position'
      }
      let response = await ExerciseService.getExercises(this.lessonId, params)
      return response.data.data
    },
    async getJudgesResultsExercises () {
      if (!this.judges || !this.judges.judge_id) return []
      let params = {
        'judge_id': this.judges.judge_id
      }
      let response = await ExecutionService.getJudgesResultsExercises(this.executionId, params)
      return response ? response.data.data : []
    },
    async saveResult (exercise) {
      if (exercise && this.judges && this.validateNumber(exercise.base_score)) {
        exercise.saving = true
        let data = {
          judge_id: this.judges.judge_id,
          secretary_id: this.judges.secretary_id,
          exercise_id: exercise.id,
          user_id: this.userId,
          base_score: exercise.base_score,
          observation: exercise.observation,
          status_id: 1
        }
        await ExecutionService.saveJudgesResultsExercises(this.executionId, data)
        exercise.saving = false
      }
    },
    validateNumber (number) {
      if (number && !isNaN(parseFloat(number)) && isFinite(number)) {
        if (this.arrayNumbers.indexOf(`${number}`) !== -1) {
          return true
        }
      }
      return false
    },
    forceRerender () {
      this.componentKey++
    }
  },
  watch: {
    windowWidth (newWidth, oldWidth) {
      this.forceRerender()
    },
    selected (newRow, oldRow) {
      this.saveResult(oldRow)
      if (newRow) {
        this.$refs.evaluationtable.toggleDetails(newRow)
        this.$nextTick(() => {
          if (oldRow) {
            this.$refs.evaluationtable.toggleDetails(oldRow)
          }
        })
      }
    },
    lessonId () {
      this.mapExercisesResults()
    },
    executionId () {
      this.mapExercisesResults()
    },
    lesson () {
      this.mapExercisesResults()
    },
    judges () {
      this.mapExercisesResults()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    userId () {
      return CredentialsService.getUser().id
    }
  }
}
</script>

<style>
  .table tr.is-selected {
    background-color: #FFCC80 !important;
    color: #212121 !important;
  }
  .table tr.detail {
    background-color: #EEEEEE !important;
    color: #212121 !important;
  }
  .table-footer{
    padding: 0.5rem 2rem !important;
  }
  .totalScore {
    font-weight: 600;
  }

  .ft-totals{
    text-align: right;
    width: 100%;
  }
  .ft-labels{
    font-size: 0.7rem;
  }
</style>
